@if (loading) {
  <div class="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center z-[99999] bg-black bg-opacity-60">
    <div class="size-20 border-4 rounded-full animate-spin border-l-transparent border-custom-500"></div>
  </div>
}
